export interface MetricLimitMapping {
  ui: string;
  queryParams: string;
  filter?: {
    key: string;
    value: string;
  }
}

export const NO_QUERY_LIMIT: MetricLimitMapping = { queryParams: "", ui: "All Queries" };
export const LAST_100_QUERIES: MetricLimitMapping = { queryParams: "&limit=100", ui: "Last 100 Queries", filter: { key: "limit", value: '100' } };
export const LAST_500_QUERIES: MetricLimitMapping = { queryParams: "&limit=500", ui: "Last 500 Queries", filter: { key: "limit", value: '500' } };
export const LAST_1K_QUERIES: MetricLimitMapping = { queryParams: "&limit=1000", ui: "Last 1k Queries", filter: { key: "limit", value: '1000' } };
export const LAST_10K_QUERIES: MetricLimitMapping = { queryParams: "&limit=10000", ui: "Last 10k Queries", filter: { key: "limit", value: '10000' } };
export const LAST_24_HOURS: MetricLimitMapping = { queryParams: "&from=24h", ui: "Last 24 Hours", filter: { key: "date", value: "24h" } };
export const LAST_7_DAYS: MetricLimitMapping = { queryParams: "&from=7d", ui: "Last 7 Days", filter: { key: "date", value: "7d" } };
export const LAST_4_WEEKS: MetricLimitMapping = { queryParams: "&from=4w", ui: "Last 4 Weeks", filter: { key: "date", value: "4w" } };
export const LAST_YEAR: MetricLimitMapping = { queryParams: "&from=365d", ui: "Last 1 Year", filter: { key: "date", value: "365d" } };

export const METRIC_LIMIT_MAPPINGS: MetricLimitMapping[] = [
  NO_QUERY_LIMIT,
  LAST_100_QUERIES,
  LAST_500_QUERIES,
  LAST_1K_QUERIES,
  LAST_10K_QUERIES,
  LAST_24_HOURS,
  LAST_7_DAYS,
  LAST_4_WEEKS,
  LAST_YEAR,
];
